import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useHook } from "./hook";
import "./styleOld.scss";

export function ReportView() {
  const { embedConfig } = useHook();

  return (
    <div className="ReportViewCustom">
      {embedConfig.value && (
        <PowerBIEmbed
          embedConfig={{
            type: "report",
            id: embedConfig?.value?.rptId,
            embedUrl: embedConfig?.value?.rptUrl,
            accessToken: embedConfig?.value?.embedToken.token,
            tokenType: models.TokenType.Embed,
            settings: {
              filterPaneEnabled: false,
              navContentPaneEnabled: false,
            },
          }}
          cssClassName={"ReportView-Report"}
          getEmbeddedComponent={(embeddedReport) => {
            console.log("Embedded Report Instance", embeddedReport);
          }}
        />
      )}
    </div>
  );
}
